import {
  Component,
  Input,
  computed,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

import { PostDetailsService } from 'src/app/core/services/post-details.service';

/**
 * Post details pane tab rendering the post's screen capture.
 *
 * `post_screen_capture` is an absolute URL served by the backend, so it is
 * bound directly as the image source — no domain prefixing.
 */
@Component({
  selector: 'app-post-screen-capture',
  templateUrl: './post-screen-capture.component.html',
  styleUrls: ['./post-screen-capture.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PostScreenCaptureComponent {
  @Input() set postId(id: string) {
    this.shownPostId.set(id);
  }

  private readonly postDetails = inject(PostDetailsService);

  /** The post this tab is showing - the pane pushes it through the setter. */
  private readonly shownPostId = signal<string | null>(null);

  readonly screenCaptureUrl = computed(
    () => this.postDetails.postFor(this.shownPostId())?.post_screen_capture,
  );

  postLoading$: Observable<boolean> = toObservable(
    computed(() => this.postDetails.isLoadingFor(this.shownPostId())),
  );
}
